module.exports = "<lifeSpaSchedule></lifeSpaSchedule>"